import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
    {
 
       // Clone the request to add withCredentials
        const modifiedReq = req.clone({
            withCredentials: true
        });        

      return next.handle(modifiedReq).pipe(
        tap(event => {
            // if(event instanceof HttpResponse) 
            // {
            //   console.log('Response received:', event);
            //   console.log('Session ID (from Set-Cookie header):', event.headers.get('Set-Cookie'));
            // }
        }),        
        catchError((error: HttpErrorResponse) => 
        {
            if(error.status === 403) 
            {
                this.authService.logout();
            }
            return throwError(error);
        })
      );
    }
  }